import { render, staticRenderFns } from "./ActionsItems.vue?vue&type=template&id=0efe0cda"
import script from "./ActionsItems.vue?vue&type=script&lang=js"
export * from "./ActionsItems.vue?vue&type=script&lang=js"
import style0 from "./ActionsItems.vue?vue&type=style&index=0&id=0efe0cda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports